import React from 'react';
import {Carousel} from 'antd'
import './index.scss'

const CarouselFooter = props => {
    const {data, toLink} = props;
    const _style = {
        height: data.height_ + 'px',
        marginBottom: data.margin_ + 'px',
    };
    return (
        <div className="layout-carousel-box" style={_style}>
            <Carousel autoplay>
                {
                    data.imgs_.map((img, index) => {
                        return (
                            <div className="img-box"
                                 key={index}
                                 role="none"
                                 onClick={() => toLink(img.target_)}>
                                <img src={img.img_ ? `${img.img_}` : ''} alt=""/>
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
};
export default CarouselFooter
